import {rtkApi} from '../apiSlice';
import {rtkActionHandler} from '../rtkHandler';
import {
    authenticateSession,
    getActivationTime, getSiteImages,
    processUserLogin,
    processUserRegistration,
    renewPassword,
    resendActivationCode,
    resetPassword,
    verifyActivationCode
} from "@/redux/apis/api";
import {RENEW_PASSWORD, RESET_PASSWORD, USER_LOGIN, USER_REGISTRATION} from "@/components/admin/login/types";
import {GENERAL_OBJECT} from "@/components/types";

const apiWithPortalAdministrationTag = rtkApi.enhanceEndpoints?.({ addTagTypes: [] });

export const loginApi = apiWithPortalAdministrationTag.injectEndpoints({
    endpoints: (builder) => ({
        processLogin: builder.mutation<any, USER_LOGIN>({
            queryFn: async (data: USER_LOGIN) => {
                return rtkActionHandler(processUserLogin(data));
            },
        }),
        resendActivationCode: builder.mutation<any, any>({
            queryFn: async (data: any) => {
                return rtkActionHandler(resendActivationCode(data));
            },
        }),
        getActivationTime: builder.query<any, null>({
            queryFn: async () => {
                return rtkActionHandler(getActivationTime());
            },
        }),
        verifyActivationCode: builder.mutation<any, number>({
            queryFn: async (activationCode: number) => {
                return rtkActionHandler(verifyActivationCode(activationCode));
            },
        }),
        resetPassword: builder.mutation<any, RESET_PASSWORD>({
            queryFn: async (data: RESET_PASSWORD) => {
                return rtkActionHandler(resetPassword(data));
            },
        }),
        renewPassword: builder.mutation<any, RENEW_PASSWORD>({
            queryFn: async (data: RENEW_PASSWORD) => {
                return rtkActionHandler(renewPassword(data));
            },
        }),
        processRegistration: builder.mutation<any, USER_REGISTRATION>({
            queryFn: async (data: USER_REGISTRATION) => {
                return rtkActionHandler(processUserRegistration(data));
            },
        }),
        authenticateSession: builder.mutation<any, GENERAL_OBJECT>({
            queryFn: async (data: GENERAL_OBJECT) => {
                return rtkActionHandler(authenticateSession(data));
            },
        }),
        getSiteImages: builder.mutation<any, null>({
            queryFn: async () => {
                return rtkActionHandler(getSiteImages());
            },
        }),
    })
});

export const {
    useProcessLoginMutation,
    useResendActivationCodeMutation,
    useGetActivationTimeQuery,
    useVerifyActivationCodeMutation,
    useResetPasswordMutation,
    useRenewPasswordMutation,
    useProcessRegistrationMutation,
    useAuthenticateSessionMutation,
    useGetSiteImagesMutation
} = loginApi;